import { Skeleton } from '@common/components';
import { cn } from '@core/utils';

const SkeletonGridRow = () => {
  return (
    <li className={cn('flex gap-24 overflow-hidden')}>
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
      <Skeleton className="size-48 shrink-0 rounded-small" />
    </li>
  );
};

const SkeletonListItem = () => {
  return (
    <li className={cn('flex grow items-center gap-16')}>
      <Skeleton className="size-104 rounded-xlarge" />
      <div className="flex grow flex-col gap-8">
        <Skeleton className="h-42 w-full rounded-xxsmall" />
        <Skeleton className="h-42 w-2/3 rounded-xxsmall" />
      </div>
    </li>
  );
};

export const MobileSkeletonCover = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'z-10 flex size-full flex-col bg-[#767676] py-8',
        className,
      )}
    >
      <div className="mx-20 mb-8 flex items-center gap-12">
        <Skeleton className="size-36 rounded-xsmall" />
        <Skeleton className="h-27 w-100 rounded-xxsmall" />
      </div>
      <div className="px-20">
        <Skeleton className="mb-24 h-120 w-full rounded-large" />
      </div>
      <ul className="mb-36 flex flex-col gap-24 pl-20">
        <SkeletonGridRow />
        <SkeletonGridRow />
      </ul>
      <div className="px-20">
        <Skeleton className="mb-16 h-30 w-214 rounded-xxsmall" />
        <ul className="flex flex-col gap-16">
          <SkeletonListItem />
          <SkeletonListItem />
          <SkeletonListItem />
          <SkeletonListItem />
          <SkeletonListItem />
        </ul>
      </div>
    </div>
  );
};
